export default {
  // baseURL: "https://xingjian.51kandianshi.com", // 服务器地址或配置的代理的路径
  timeout: 10000, // 超时时间
  headers: {
    // "Content-Type": "application/x-www-form-urlencoded",
    'Content-Type': 'application/json;charset=utf-8'
  } // 配置请求头
}
